import React, { createContext, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import Appointment from "../Appointment/Appointment";
import Checkout from "../Checkout/Checkout";
import Home from "../Home/Home";
import MedicineList from "../MedicineList/MedicineList";
import PharmacyList from "../PharmacyList/PharmacyList";
// import PrivateRoute from '../PrivateRoute/PrivateRoute';
import Login from "../Login/Login";
import Registration from "../Login/Registration";
import Profile from "../Profile/Profile";
import axios from "axios";
export const context = createContext();
const FrontPanel = () => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [pharmacyDataDetails, setPharmacyDataDetails] = useState({});
  const [cart, setCart] = useState([]);
  const [isSignedIn, setIsSignedIn] = useState(false);
  const [update, setUpdate] = useState(false);
  const [userData, setUserData] = useState({});
  const [loginModalIsOpen, setIsLoginOpen] = useState(false);
  const [isRegister, setIsRegister] = useState(false);
  const [address, setAddress] = useState(null);

  const [vatTaxDelivery, setvatTaxDelivery] = useState({
    vat: 0,
    delivery_charge: 0,
  });

  useEffect(() => {
    const user =
      JSON.parse(localStorage.getItem("user")) ||
      JSON.parse(sessionStorage.getItem("user"));

    setIsSignedIn(user?.user?.user_type === "customer");
    setUserData(user);
  }, [update]);

  {
    process.env.NODE_ENV === "development"
      ? (axios.defaults.baseURL = process.env.REACT_APP_DEV_MODE_URL)
      : (axios.defaults.baseURL = process.env.REACT_APP_PRO_MODE_URL);
  }

  //   axios.defaults.baseURL = "http://localhost:8000/api";
  // axios.defaults.baseURL = 'http://dashboard.greatdoc.org/server/public/api';
  if (sessionStorage.getItem("user") !== null) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${JSON.parse(sessionStorage.getItem("user")).token
      }`;
  } else if (localStorage.getItem("user") !== null) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${JSON.parse(localStorage.getItem("user")).token
      }`;
  }
  console.log(isSignedIn, "isSignedIn");
  return (
    <context.Provider
      value={{
        pharmacyDataDetails,
        setPharmacyDataDetails,
        cart,
        setCart,
        modalIsOpen,
        setIsOpen,
        update,
        setUpdate,
        setIsSignedIn,
        isSignedIn,
        userData,
        setUserData,
        loginModalIsOpen,
        setIsLoginOpen,
        isRegister,
        setIsRegister,
        vatTaxDelivery,
        setvatTaxDelivery,
      }}
    >

      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/login" element={<Login />}></Route>
        <Route path="/register" element={<Registration />}></Route>
        <Route
          path="/pharmacy-list/:address"
          element={<PharmacyList />}
        ></Route>
        <Route path="/medicine-list/:id" element={<MedicineList />}></Route>
        {isSignedIn && (
          <Route path="checkout/:id" element={<Checkout />}></Route>
        )}

        <Route path="appointment/:id" element={<Appointment />}></Route>
        <Route path="/profile/:id" element={<Profile />}></Route>
      </Routes>
    </context.Provider>
  );
};

export default FrontPanel;
